<template>
	<div class="content-box">
		<router-view/>
	</div>
</template>

<script>

    import Paginate from 'vuejs-paginate'
    export default {
        name: 'bankAccounts',
	    components: {  Paginate },
        data () {
            return {
                t: this.$root.t,
                session: session,
            }
        },
	    mounted () {
	    },
	    methods:
	    {
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.list-group {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		padding-left: 0;
		margin-bottom: 0;
	}
	.list-group-item:first-child {
		border-top-left-radius: .25rem;
		border-top-right-radius: .25rem;
	}
	.list-group-item {
		position: relative;
		display: block;
		padding: .75rem 1.25rem;
		margin-bottom: -1px;
		background-color: #fff;
		border: 1px solid rgba(0,0,0,.125);
	}
</style>



// WEBPACK FOOTER //
// src/components/user/account/bankAccounts.vue